/**
 * СГЕНЕРИРОВАННЫЙ ФАЙЛ — правки затрёт генератор.
 *
 * Источник: ассеты `minecraft-assets` для 1.21.11 (пакет отдаёт
 * фоллбэк 1.21.8 — имена блоков 26.2 в нём есть), средний цвет верхней грани
 * блока, квантованный до 255 цветов.
 *
 * Перегенерация: `corepack pnpm minimap:palette`
 * Генератор и мотивация: `scripts/build-minimap-palette.mjs`
 */

/** Цвет по индексу из клетки мини-карты. Индекс 0 — «нет данных». */
export const MINIMAP_COLOR_TABLE: readonly (readonly [number, number, number])[] = [
  [0, 0, 0],
  [17, 20, 24],
  [34, 16, 56],
  [37, 27, 24],
  [110, 2, 1],
  [28, 36, 62],
  [82, 17, 20],
  [39, 35, 41],
  [8, 49, 59],
  [58, 38, 23],
  [52, 40, 43],
  [36, 46, 63],
  [134, 8, 6],
  [68, 39, 25],
  [17, 67, 25],
  [122, 14, 32],
  [7, 70, 84],
  [45, 60, 37],
  [52, 53, 61],
  [78, 51, 26],
  [43, 73, 9],
  [92, 13, 194],
  [58, 57, 64],
  [49, 68, 44],
  [104, 41, 41],
  [53, 72, 17],
  [70, 59, 45],
  [42, 56, 141],
  [48, 81, 17],
  [84, 60, 33],
  [118, 42, 40],
  [141, 32, 32],
  [28, 79, 101],
  [85, 62, 45],
  [53, 57, 157],
  [176, 25, 5],
  [104, 33, 158],
  [49, 80, 68],
  [69, 70, 71],
  [108, 51, 73],
  [105, 40, 154],
  [81, 76, 34],
  [76, 69, 86],
  [156, 37, 41],
  [107, 62, 41],
  [64, 86, 34],
  [78, 72, 71],
  [75, 74, 76],
  [161, 39, 35],
  [79, 75, 68],
  [76, 76, 76],
  [41, 95, 72],
  [63, 81, 92],
  [88, 69, 90],
  [159, 43, 49],
  [122, 62, 50],
  [9, 128, 16],
  [51, 79, 160],
  [57, 74, 172],
  [68, 96, 31],
  [143, 56, 42],
  [122, 42, 173],
  [73, 94, 34],
  [163, 25, 161],
  [120, 63, 85],
  [45, 110, 40],
  [107, 78, 45],
  [137, 57, 90],
  [79, 88, 86],
  [86, 85, 85],
  [160, 33, 159],
  [43, 105, 99],
  [49, 122, 7],
  [172, 51, 50],
  [79, 101, 37],
  [49, 87, 204],
  [116, 78, 78],
  [23, 120, 121],
  [21, 120, 136],
  [115, 88, 56],
  [200, 47, 45],
  [161, 46, 153],
  [132, 56, 178],
  [89, 95, 92],
  [85, 110, 28],
  [83, 107, 51],
  [125, 62, 175],
  [43, 117, 107],
  [78, 99, 112],
  [64, 110, 99],
  [47, 120, 112],
  [98, 98, 98],
  [59, 130, 41],
  [19, 135, 124],
  [90, 114, 49],
  [52, 119, 125],
  [57, 135, 31],
  [88, 119, 44],
  [110, 100, 86],
  [102, 102, 100],
  [111, 99, 101],
  [21, 138, 145],
  [156, 90, 49],
  [52, 129, 124],
  [135, 99, 63],
  [178, 57, 168],
  [157, 86, 74],
  [113, 117, 30],
  [98, 123, 47],
  [98, 123, 49],
  [160, 90, 57],
  [103, 122, 51],
  [124, 103, 99],
  [150, 88, 109],
  [129, 103, 90],
  [88, 134, 40],
  [135, 105, 68],
  [20, 151, 133],
  [76, 141, 38],
  [170, 91, 54],
  [70, 132, 109],
  [74, 123, 147],
  [92, 124, 98],
  [80, 121, 147],
  [115, 115, 91],
  [114, 121, 67],
  [138, 106, 84],
  [146, 103, 79],
  [36, 137, 199],
  [35, 138, 197],
  [139, 97, 139],
  [76, 127, 153],
  [94, 143, 26],
  [104, 126, 93],
  [153, 104, 84],
  [118, 117, 110],
  [184, 99, 30],
  [217, 75, 68],
  [171, 74, 209],
  [148, 113, 73],
  [133, 98, 190],
  [48, 150, 153],
  [191, 103, 33],
  [119, 123, 119],
  [114, 139, 53],
  [111, 145, 31],
  [145, 115, 100],
  [178, 76, 216],
  [129, 110, 171],
  [183, 102, 76],
  [123, 122, 136],
  [108, 136, 116],
  [149, 119, 97],
  [142, 129, 68],
  [117, 142, 67],
  [114, 130, 141],
  [226, 101, 6],
  [203, 84, 154],
  [193, 84, 185],
  [80, 153, 127],
  [133, 127, 124],
  [47, 163, 168],
  [191, 107, 81],
  [217, 105, 26],
  [192, 108, 79],
  [107, 146, 107],
  [99, 157, 78],
  [81, 158, 129],
  [97, 171, 24],
  [195, 110, 82],
  [166, 139, 12],
  [207, 91, 159],
  [107, 153, 111],
  [158, 120, 148],
  [164, 131, 76],
  [207, 96, 146],
  [109, 153, 110],
  [49, 164, 212],
  [84, 162, 132],
  [169, 128, 85],
  [152, 134, 100],
  [204, 121, 37],
  [95, 170, 78],
  [162, 131, 107],
  [186, 133, 35],
  [91, 163, 140],
  [98, 147, 209],
  [141, 141, 139],
  [42, 203, 88],
  [128, 161, 80],
  [208, 100, 192],
  [241, 118, 20],
  [177, 134, 108],
  [58, 175, 217],
  [102, 153, 216],
  [112, 185, 26],
  [171, 127, 171],
  [161, 128, 199],
  [99, 172, 158],
  [179, 145, 88],
  [95, 165, 209],
  [148, 172, 43],
  [224, 136, 38],
  [151, 152, 151],
  [74, 181, 213],
  [213, 142, 53],
  [118, 184, 94],
  [138, 164, 158],
  [125, 197, 30],
  [158, 159, 164],
  [232, 123, 159],
  [241, 146, 18],
  [56, 204, 209],
  [116, 168, 253],
  [202, 160, 75],
  [209, 165, 50],
  [241, 147, 71],
  [167, 190, 63],
  [195, 172, 89],
  [222, 169, 47],
  [236, 140, 173],
  [193, 181, 77],
  [194, 174, 117],
  [192, 175, 121],
  [221, 158, 154],
  [208, 185, 62],
  [203, 183, 86],
  [143, 182, 252],
  [195, 180, 134],
  [207, 186, 89],
  [235, 155, 182],
  [245, 182, 25],
  [210, 178, 161],
  [174, 204, 135],
  [191, 191, 192],
  [225, 196, 78],
  [226, 178, 171],
  [208, 194, 151],
  [241, 199, 48],
  [98, 237, 228],
  [171, 205, 204],
  [196, 195, 195],
  [203, 197, 186],
  [225, 194, 161],
  [206, 200, 195],
  [205, 206, 175],
  [183, 213, 211],
  [232, 219, 54],
  [247, 181, 219],
  [220, 214, 162],
  [211, 215, 214],
  [220, 222, 221],
  [230, 227, 205],
  [241, 231, 218],
  [231, 234, 230],
  [249, 250, 250]
]

/** Имя блока (без `minecraft:`) → индекс в `MINIMAP_COLOR_TABLE`. */
export const MINIMAP_BLOCK_COLOR_INDEX: Readonly<Record<string, number>> = {
  acacia_button: 119,
  acacia_door: 110,
  acacia_fence: 119,
  acacia_fence_gate: 119,
  acacia_hanging_sign: 119,
  acacia_leaves: 59,
  acacia_log: 102,
  acacia_planks: 119,
  acacia_pressure_plate: 119,
  acacia_sapling: 107,
  acacia_sign: 119,
  acacia_slab: 119,
  acacia_stairs: 119,
  acacia_trapdoor: 102,
  acacia_wall_hanging_sign: 119,
  acacia_wall_sign: 119,
  acacia_wood: 98,
  activator_rail: 76,
  allium: 197,
  amethyst_block: 140,
  amethyst_cluster: 197,
  ancient_debris: 46,
  andesite: 187,
  andesite_slab: 187,
  andesite_stairs: 187,
  andesite_wall: 187,
  anvil: 46,
  attached_melon_stem: 94,
  attached_pumpkin_stem: 94,
  azalea: 111,
  azalea_leaves: 20,
  azure_bluet: 233,
  bamboo: 132,
  bamboo_block: 144,
  bamboo_button: 218,
  bamboo_door: 218,
  bamboo_fence: 229,
  bamboo_fence_gate: 226,
  bamboo_hanging_sign: 218,
  bamboo_mosaic: 221,
  bamboo_mosaic_slab: 221,
  bamboo_mosaic_stairs: 221,
  bamboo_planks: 218,
  bamboo_pressure_plate: 218,
  bamboo_sapling: 25,
  bamboo_sign: 218,
  bamboo_slab: 218,
  bamboo_stairs: 218,
  bamboo_trapdoor: 226,
  bamboo_wall_hanging_sign: 218,
  bamboo_wall_sign: 218,
  barrel: 104,
  basalt: 53,
  beacon: 246,
  bedrock: 69,
  bee_nest: 214,
  beehive: 199,
  beetroots: 118,
  bell: 13,
  big_dripleaf: 144,
  big_dripleaf_stem: 94,
  birch_button: 223,
  birch_door: 237,
  birch_fence: 223,
  birch_fence_gate: 223,
  birch_hanging_sign: 222,
  birch_leaves: 45,
  birch_log: 228,
  birch_planks: 223,
  birch_pressure_plate: 223,
  birch_sapling: 189,
  birch_sign: 223,
  birch_slab: 223,
  birch_stairs: 223,
  birch_trapdoor: 237,
  birch_wall_hanging_sign: 222,
  birch_wall_sign: 223,
  birch_wood: 250,
  black_banner: 174,
  black_bed: 174,
  black_candle: 5,
  black_candle_cake: 5,
  black_carpet: 1,
  black_concrete: 1,
  black_concrete_powder: 7,
  black_glazed_terracotta: 13,
  black_shulker_box: 3,
  black_stained_glass: 1,
  black_stained_glass_pane: 1,
  black_terracotta: 3,
  black_wall_banner: 174,
  black_wool: 1,
  blackstone: 7,
  blackstone_slab: 7,
  blackstone_stairs: 7,
  blackstone_wall: 7,
  blast_furnace: 68,
  blue_banner: 174,
  blue_bed: 174,
  blue_candle: 57,
  blue_candle_cake: 57,
  blue_carpet: 34,
  blue_concrete: 27,
  blue_concrete_powder: 58,
  blue_glazed_terracotta: 27,
  blue_ice: 213,
  blue_orchid: 161,
  blue_shulker_box: 27,
  blue_stained_glass: 58,
  blue_stained_glass_pane: 58,
  blue_terracotta: 42,
  blue_wall_banner: 174,
  blue_wool: 34,
  bone_block: 245,
  bookshelf: 174,
  brain_coral: 175,
  brain_coral_block: 171,
  brain_coral_fan: 157,
  brain_coral_wall_fan: 157,
  brewing_stand: 98,
  brick_slab: 134,
  brick_stairs: 134,
  brick_wall: 134,
  bricks: 134,
  brown_banner: 174,
  brown_bed: 174,
  brown_candle: 44,
  brown_candle_cake: 44,
  brown_carpet: 66,
  brown_concrete: 29,
  brown_concrete_powder: 79,
  brown_glazed_terracotta: 98,
  brown_mushroom: 146,
  brown_mushroom_block: 139,
  brown_shulker_box: 44,
  brown_stained_glass: 79,
  brown_stained_glass_pane: 66,
  brown_terracotta: 19,
  brown_wall_banner: 174,
  brown_wool: 66,
  bubble_column: 57,
  bubble_coral: 63,
  bubble_coral_block: 63,
  bubble_coral_fan: 70,
  bubble_coral_wall_fan: 70,
  budding_amethyst: 140,
  cactus: 97,
  cake: 253,
  calcite: 251,
  calibrated_sculk_sensor: 32,
  campfire: 49,
  candle: 243,
  candle_cake: 243,
  carrots: 65,
  cartography_table: 79,
  carved_pumpkin: 181,
  cauldron: 46,
  cave_vines: 20,
  cave_vines_plant: 20,
  chain: 18,
  chain_command_block: 207,
  cherry_button: 243,
  cherry_door: 236,
  cherry_fence: 243,
  cherry_fence_gate: 243,
  cherry_hanging_sign: 224,
  cherry_leaves: 107,
  cherry_log: 10,
  cherry_planks: 243,
  cherry_pressure_plate: 243,
  cherry_sapling: 173,
  cherry_sign: 243,
  cherry_slab: 243,
  cherry_stairs: 243,
  cherry_trapdoor: 236,
  cherry_wall_hanging_sign: 224,
  cherry_wall_sign: 243,
  cherry_wood: 10,
  chest: 174,
  chipped_anvil: 46,
  chiseled_bookshelf: 199,
  chiseled_copper: 149,
  chiseled_deepslate: 22,
  chiseled_nether_bricks: 9,
  chiseled_polished_blackstone: 22,
  chiseled_quartz_block: 252,
  chiseled_red_sandstone: 136,
  chiseled_sandstone: 249,
  chiseled_stone_bricks: 143,
  chiseled_tuff: 83,
  chiseled_tuff_bricks: 135,
  chorus_flower: 173,
  chorus_plant: 53,
  clay: 209,
  coal_block: 1,
  coal_ore: 99,
  coarse_dirt: 79,
  cobbled_deepslate: 42,
  cobbled_deepslate_slab: 42,
  cobbled_deepslate_stairs: 42,
  cobbled_deepslate_wall: 42,
  cobblestone: 160,
  cobblestone_slab: 160,
  cobblestone_stairs: 160,
  cobblestone_wall: 160,
  cobweb: 254,
  cocoa: 153,
  command_block: 192,
  comparator: 44,
  composter: 102,
  conduit: 183,
  copper_block: 169,
  copper_bulb: 110,
  copper_door: 149,
  copper_grate: 164,
  copper_ore: 160,
  copper_trapdoor: 162,
  cornflower: 123,
  cracked_deepslate_bricks: 38,
  cracked_deepslate_tiles: 18,
  cracked_nether_bricks: 3,
  cracked_polished_blackstone_bricks: 7,
  cracked_stone_bricks: 143,
  crafter: 112,
  crafting_table: 66,
  creeper_head: 33,
  creeper_wall_head: 33,
  crimson_button: 39,
  crimson_door: 39,
  crimson_fence: 39,
  crimson_fence_gate: 39,
  crimson_fungus: 60,
  crimson_hanging_sign: 67,
  crimson_hyphae: 6,
  crimson_nylium: 30,
  crimson_planks: 39,
  crimson_pressure_plate: 39,
  crimson_roots: 15,
  crimson_sign: 39,
  crimson_slab: 39,
  crimson_stairs: 39,
  crimson_stem: 39,
  crimson_trapdoor: 39,
  crimson_wall_hanging_sign: 67,
  crimson_wall_sign: 39,
  crying_obsidian: 2,
  cut_copper: 162,
  cut_copper_slab: 162,
  cut_copper_stairs: 162,
  cut_red_sandstone: 136,
  cut_red_sandstone_slab: 136,
  cut_sandstone: 249,
  cut_sandstone_slab: 249,
  cyan_banner: 174,
  cyan_bed: 174,
  cyan_candle: 93,
  cyan_candle_cake: 93,
  cyan_carpet: 101,
  cyan_concrete: 78,
  cyan_concrete_powder: 141,
  cyan_glazed_terracotta: 95,
  cyan_shulker_box: 78,
  cyan_stained_glass: 131,
  cyan_stained_glass_pane: 121,
  cyan_terracotta: 83,
  cyan_wall_banner: 174,
  cyan_wool: 101,
  damaged_anvil: 38,
  dandelion: 201,
  dark_oak_button: 13,
  dark_oak_door: 19,
  dark_oak_fence: 13,
  dark_oak_fence_gate: 13,
  dark_oak_hanging_sign: 29,
  dark_oak_leaves: 59,
  dark_oak_log: 13,
  dark_oak_planks: 13,
  dark_oak_pressure_plate: 13,
  dark_oak_sapling: 59,
  dark_oak_sign: 13,
  dark_oak_slab: 13,
  dark_oak_stairs: 13,
  dark_oak_trapdoor: 19,
  dark_oak_wall_hanging_sign: 29,
  dark_oak_wall_sign: 13,
  dark_oak_wood: 9,
  dark_prismarine: 51,
  dark_prismarine_slab: 51,
  dark_prismarine_stairs: 51,
  daylight_detector: 146,
  dead_brain_coral: 160,
  dead_brain_coral_block: 135,
  dead_brain_coral_fan: 160,
  dead_brain_coral_wall_fan: 160,
  dead_bubble_coral: 160,
  dead_bubble_coral_block: 160,
  dead_bubble_coral_fan: 160,
  dead_bubble_coral_wall_fan: 160,
  dead_bush: 66,
  dead_fire_coral: 160,
  dead_fire_coral_block: 160,
  dead_fire_coral_fan: 135,
  dead_fire_coral_wall_fan: 135,
  dead_horn_coral: 160,
  dead_horn_coral_block: 160,
  dead_horn_coral_fan: 160,
  dead_horn_coral_wall_fan: 160,
  dead_tube_coral: 135,
  dead_tube_coral_block: 160,
  dead_tube_coral_fan: 160,
  dead_tube_coral_wall_fan: 160,
  decorated_pot: 106,
  deepslate: 69,
  deepslate_brick_slab: 38,
  deepslate_brick_stairs: 38,
  deepslate_brick_wall: 38,
  deepslate_bricks: 38,
  deepslate_coal_ore: 47,
  deepslate_copper_ore: 83,
  deepslate_diamond_ore: 88,
  deepslate_emerald_ore: 68,
  deepslate_gold_ore: 98,
  deepslate_iron_ore: 98,
  deepslate_lapis_ore: 88,
  deepslate_redstone_ore: 76,
  deepslate_tile_slab: 22,
  deepslate_tile_stairs: 22,
  deepslate_tile_wall: 22,
  deepslate_tiles: 22,
  detector_rail: 98,
  diamond_block: 239,
  diamond_ore: 155,
  diorite: 234,
  diorite_slab: 234,
  diorite_stairs: 234,
  diorite_wall: 234,
  dirt: 104,
  dirt_path: 139,
  dispenser: 99,
  dragon_egg: 1,
  dragon_head: 33,
  dragon_wall_head: 33,
  dried_kelp_block: 23,
  dripstone_block: 126,
  dropper: 91,
  emerald_block: 188,
  emerald_ore: 151,
  enchanting_table: 76,
  end_gateway: 1,
  end_portal: 1,
  end_portal_frame: 122,
  end_rod: 244,
  end_stone: 249,
  end_stone_brick_slab: 249,
  end_stone_brick_stairs: 249,
  end_stone_brick_wall: 249,
  end_stone_bricks: 249,
  ender_chest: 1,
  exposed_chiseled_copper: 152,
  exposed_copper: 183,
  exposed_copper_bulb: 126,
  exposed_copper_door: 146,
  exposed_copper_grate: 183,
  exposed_copper_trapdoor: 183,
  exposed_cut_copper: 180,
  exposed_cut_copper_slab: 180,
  exposed_cut_copper_stairs: 180,
  farmland: 127,
  fern: 59,
  fire: 205,
  fire_coral: 73,
  fire_coral_block: 54,
  fire_coral_fan: 43,
  fire_coral_wall_fan: 43,
  fletching_table: 228,
  flower_pot: 55,
  flowering_azalea: 125,
  flowering_azalea_leaves: 20,
  frogspawn: 98,
  frosted_ice: 227,
  furnace: 135,
  gilded_blackstone: 10,
  glass: 246,
  glass_pane: 240,
  glow_lichen: 143,
  glowstone: 179,
  gold_block: 247,
  gold_ore: 180,
  granite: 127,
  granite_slab: 127,
  granite_stairs: 127,
  granite_wall: 127,
  grass_block: 94,
  gravel: 160,
  gray_banner: 174,
  gray_bed: 174,
  gray_candle: 68,
  gray_candle_cake: 68,
  gray_carpet: 38,
  gray_concrete: 22,
  gray_concrete_powder: 68,
  gray_glazed_terracotta: 83,
  gray_shulker_box: 22,
  gray_stained_glass: 50,
  gray_stained_glass_pane: 46,
  gray_terracotta: 10,
  gray_wall_banner: 174,
  gray_wool: 38,
  green_banner: 174,
  green_bed: 174,
  green_candle: 62,
  green_candle_cake: 62,
  green_carpet: 84,
  green_concrete: 62,
  green_concrete_powder: 94,
  green_glazed_terracotta: 154,
  green_shulker_box: 74,
  green_stained_glass: 144,
  green_stained_glass_pane: 109,
  green_terracotta: 41,
  green_wall_banner: 174,
  green_wool: 84,
  grindstone: 187,
  hanging_roots: 179,
  hay_block: 170,
  heavy_weighted_pressure_plate: 251,
  honey_block: 211,
  honeycomb_block: 202,
  hopper: 47,
  horn_coral: 225,
  horn_coral_block: 235,
  horn_coral_fan: 225,
  horn_coral_wall_fan: 225,
  ice: 227,
  infested_chiseled_stone_bricks: 143,
  infested_cobblestone: 160,
  infested_cracked_stone_bricks: 143,
  infested_deepslate: 69,
  infested_mossy_stone_bricks: 135,
  infested_stone: 160,
  infested_stone_bricks: 143,
  iron_bars: 187,
  iron_block: 251,
  iron_door: 241,
  iron_ore: 160,
  iron_trapdoor: 244,
  jack_o_lantern: 181,
  jigsaw: 10,
  jukebox: 33,
  jungle_button: 139,
  jungle_door: 139,
  jungle_fence: 139,
  jungle_fence_gate: 139,
  jungle_hanging_sign: 179,
  jungle_leaves: 74,
  jungle_log: 139,
  jungle_planks: 139,
  jungle_pressure_plate: 139,
  jungle_sapling: 28,
  jungle_sign: 139,
  jungle_slab: 139,
  jungle_stairs: 139,
  jungle_trapdoor: 139,
  jungle_wall_hanging_sign: 179,
  jungle_wall_sign: 139,
  jungle_wood: 41,
  kelp: 115,
  kelp_plant: 115,
  ladder: 79,
  lantern: 98,
  lapis_block: 27,
  lapis_ore: 155,
  large_amethyst_bud: 197,
  large_fern: 74,
  lava: 163,
  lava_cauldron: 46,
  lectern: 179,
  lever: 79,
  light_blue_banner: 174,
  light_blue_bed: 174,
  light_blue_candle: 129,
  light_blue_candle_cake: 129,
  light_blue_carpet: 193,
  light_blue_concrete: 128,
  light_blue_concrete_powder: 204,
  light_blue_glazed_terracotta: 200,
  light_blue_shulker_box: 177,
  light_blue_stained_glass: 194,
  light_blue_stained_glass_pane: 186,
  light_blue_terracotta: 150,
  light_blue_wall_banner: 174,
  light_blue_wool: 193,
  light_gray_banner: 174,
  light_gray_bed: 174,
  light_gray_candle: 135,
  light_gray_candle_cake: 135,
  light_gray_carpet: 187,
  light_gray_concrete: 143,
  light_gray_concrete_powder: 203,
  light_gray_glazed_terracotta: 207,
  light_gray_shulker_box: 135,
  light_gray_stained_glass: 209,
  light_gray_stained_glass_pane: 187,
  light_gray_terracotta: 112,
  light_gray_wall_banner: 174,
  light_gray_wool: 187,
  light_weighted_pressure_plate: 247,
  lightning_rod: 169,
  lilac: 160,
  lily_of_the_valley: 206,
  lily_pad: 14,
  lime_banner: 174,
  lime_bed: 174,
  lime_candle: 168,
  lime_candle_cake: 168,
  lime_carpet: 195,
  lime_concrete: 168,
  lime_concrete_powder: 208,
  lime_glazed_terracotta: 217,
  lime_shulker_box: 168,
  lime_stained_glass: 208,
  lime_stained_glass_pane: 208,
  lime_terracotta: 111,
  lime_wall_banner: 174,
  lime_wool: 195,
  lodestone: 203,
  loom: 152,
  magenta_banner: 174,
  magenta_bed: 174,
  magenta_candle: 81,
  magenta_candle_cake: 81,
  magenta_carpet: 105,
  magenta_concrete: 105,
  magenta_concrete_powder: 158,
  magenta_glazed_terracotta: 190,
  magenta_shulker_box: 105,
  magenta_stained_glass: 147,
  magenta_stained_glass_pane: 138,
  magenta_terracotta: 113,
  magenta_wall_banner: 174,
  magenta_wool: 105,
  magma_block: 60,
  mangrove_button: 55,
  mangrove_door: 30,
  mangrove_fence: 55,
  mangrove_fence_gate: 55,
  mangrove_hanging_sign: 55,
  mangrove_leaves: 45,
  mangrove_log: 44,
  mangrove_planks: 55,
  mangrove_pressure_plate: 55,
  mangrove_propagule: 182,
  mangrove_roots: 29,
  mangrove_sign: 55,
  mangrove_slab: 55,
  mangrove_stairs: 55,
  mangrove_trapdoor: 30,
  mangrove_wall_hanging_sign: 55,
  mangrove_wall_sign: 55,
  mangrove_wood: 33,
  medium_amethyst_bud: 197,
  melon: 145,
  melon_stem: 94,
  moss_block: 97,
  moss_carpet: 97,
  mossy_cobblestone: 124,
  mossy_cobblestone_slab: 124,
  mossy_cobblestone_stairs: 124,
  mossy_cobblestone_wall: 124,
  mossy_stone_brick_slab: 135,
  mossy_stone_brick_stairs: 135,
  mossy_stone_brick_wall: 135,
  mossy_stone_bricks: 135,
  moving_piston: 99,
  mud: 22,
  mud_brick_slab: 126,
  mud_brick_stairs: 126,
  mud_brick_wall: 126,
  mud_bricks: 126,
  muddy_mangrove_roots: 26,
  mushroom_stem: 242,
  mycelium: 100,
  nether_brick_fence: 3,
  nether_brick_slab: 3,
  nether_brick_stairs: 3,
  nether_brick_wall: 3,
  nether_bricks: 3,
  nether_gold_ore: 44,
  nether_portal: 21,
  nether_quartz_ore: 55,
  nether_sprouts: 117,
  nether_wart: 15,
  nether_wart_block: 4,
  netherite_block: 22,
  netherrack: 24,
  note_block: 33,
  oak_button: 174,
  oak_door: 139,
  oak_fence: 174,
  oak_fence_gate: 174,
  oak_hanging_sign: 199,
  oak_leaves: 59,
  oak_log: 153,
  oak_planks: 174,
  oak_pressure_plate: 174,
  oak_sapling: 74,
  oak_sign: 174,
  oak_slab: 174,
  oak_stairs: 174,
  oak_trapdoor: 79,
  oak_wall_hanging_sign: 199,
  oak_wall_sign: 174,
  oak_wood: 79,
  observer: 91,
  obsidian: 1,
  ochre_froglight: 253,
  orange_banner: 174,
  orange_bed: 174,
  orange_candle: 156,
  orange_candle_cake: 156,
  orange_carpet: 191,
  orange_concrete: 156,
  orange_concrete_powder: 202,
  orange_glazed_terracotta: 180,
  orange_shulker_box: 156,
  orange_stained_glass: 202,
  orange_stained_glass_pane: 181,
  orange_terracotta: 102,
  orange_tulip: 132,
  orange_wall_banner: 174,
  orange_wool: 191,
  oxeye_daisy: 233,
  oxidized_chiseled_copper: 178,
  oxidized_copper: 185,
  oxidized_copper_bulb: 120,
  oxidized_copper_door: 159,
  oxidized_copper_grate: 167,
  oxidized_copper_trapdoor: 178,
  oxidized_cut_copper: 167,
  oxidized_cut_copper_slab: 167,
  oxidized_cut_copper_stairs: 167,
  packed_ice: 227,
  packed_mud: 126,
  pearlescent_froglight: 255,
  peony: 83,
  petrified_oak_slab: 174,
  piglin_head: 33,
  piglin_wall_head: 33,
  pink_banner: 174,
  pink_bed: 174,
  pink_candle: 175,
  pink_candle_cake: 175,
  pink_carpet: 220,
  pink_concrete: 175,
  pink_concrete_powder: 220,
  pink_glazed_terracotta: 230,
  pink_petals: 248,
  pink_shulker_box: 210,
  pink_stained_glass: 220,
  pink_stained_glass_pane: 210,
  pink_terracotta: 106,
  pink_tulip: 166,
  pink_wall_banner: 174,
  pink_wool: 220,
  piston: 99,
  piston_head: 99,
  pitcher_crop: 218,
  pitcher_plant: 133,
  player_head: 33,
  player_wall_head: 33,
  podzol: 29,
  pointed_dripstone: 114,
  polished_andesite: 150,
  polished_andesite_slab: 150,
  polished_andesite_stairs: 150,
  polished_basalt: 99,
  polished_blackstone: 18,
  polished_blackstone_brick_slab: 10,
  polished_blackstone_brick_stairs: 10,
  polished_blackstone_brick_wall: 10,
  polished_blackstone_bricks: 10,
  polished_blackstone_button: 18,
  polished_blackstone_pressure_plate: 18,
  polished_blackstone_slab: 18,
  polished_blackstone_stairs: 18,
  polished_blackstone_wall: 18,
  polished_deepslate: 38,
  polished_deepslate_slab: 38,
  polished_deepslate_stairs: 38,
  polished_deepslate_wall: 38,
  polished_diorite: 234,
  polished_diorite_slab: 234,
  polished_diorite_stairs: 234,
  polished_granite: 134,
  polished_granite_slab: 134,
  polished_granite_stairs: 134,
  polished_tuff: 99,
  polished_tuff_slab: 99,
  polished_tuff_stairs: 99,
  polished_tuff_wall: 99,
  poppy: 55,
  potatoes: 92,
  potted_acacia_sapling: 55,
  potted_allium: 55,
  potted_azalea_bush: 108,
  potted_azure_bluet: 55,
  potted_bamboo: 132,
  potted_birch_sapling: 55,
  potted_blue_orchid: 55,
  potted_brown_mushroom: 55,
  potted_cactus: 97,
  potted_cherry_sapling: 55,
  potted_cornflower: 55,
  potted_crimson_fungus: 55,
  potted_crimson_roots: 55,
  potted_dandelion: 55,
  potted_dark_oak_sapling: 55,
  potted_dead_bush: 55,
  potted_fern: 19,
  potted_flowering_azalea_bush: 125,
  potted_jungle_sapling: 55,
  potted_lily_of_the_valley: 55,
  potted_mangrove_propagule: 55,
  potted_oak_sapling: 55,
  potted_orange_tulip: 55,
  potted_oxeye_daisy: 55,
  potted_pink_tulip: 55,
  potted_poppy: 55,
  potted_red_mushroom: 55,
  potted_red_tulip: 55,
  potted_spruce_sapling: 55,
  potted_torchflower: 55,
  potted_warped_fungus: 55,
  potted_warped_roots: 55,
  potted_white_tulip: 55,
  potted_wither_rose: 55,
  powder_snow: 255,
  powder_snow_cauldron: 46,
  powered_rail: 139,
  prismarine: 185,
  prismarine_brick_slab: 198,
  prismarine_brick_stairs: 198,
  prismarine_bricks: 198,
  prismarine_slab: 185,
  prismarine_stairs: 185,
  prismarine_wall: 185,
  pumpkin: 181,
  pumpkin_stem: 94,
  purple_banner: 174,
  purple_bed: 174,
  purple_candle: 36,
  purple_candle_cake: 36,
  purple_carpet: 61,
  purple_concrete: 40,
  purple_concrete_powder: 82,
  purple_glazed_terracotta: 40,
  purple_shulker_box: 36,
  purple_stained_glass: 86,
  purple_stained_glass_pane: 86,
  purple_terracotta: 64,
  purple_wall_banner: 174,
  purple_wool: 61,
  purpur_block: 196,
  purpur_pillar: 196,
  purpur_slab: 196,
  purpur_stairs: 196,
  quartz_block: 253,
  quartz_bricks: 253,
  quartz_pillar: 253,
  quartz_slab: 253,
  quartz_stairs: 253,
  rail: 124,
  raw_copper_block: 134,
  raw_gold_block: 219,
  raw_iron_block: 183,
  red_banner: 174,
  red_bed: 174,
  red_candle: 43,
  red_candle_cake: 43,
  red_carpet: 48,
  red_concrete: 31,
  red_concrete_powder: 73,
  red_glazed_terracotta: 73,
  red_mushroom: 137,
  red_mushroom_block: 80,
  red_nether_brick_slab: 6,
  red_nether_brick_stairs: 6,
  red_nether_brick_wall: 6,
  red_nether_bricks: 6,
  red_sand: 142,
  red_sandstone: 136,
  red_sandstone_slab: 136,
  red_sandstone_stairs: 136,
  red_sandstone_wall: 136,
  red_shulker_box: 31,
  red_stained_glass: 54,
  red_stained_glass_pane: 60,
  red_terracotta: 60,
  red_tulip: 115,
  red_wall_banner: 174,
  red_wool: 48,
  redstone_block: 35,
  redstone_lamp: 19,
  redstone_ore: 146,
  redstone_torch: 44,
  redstone_wall_torch: 44,
  redstone_wire: 12,
  reinforced_deepslate: 68,
  repeater: 44,
  repeating_command_block: 148,
  respawn_anchor: 2,
  rooted_dirt: 126,
  rose_bush: 66,
  sand: 249,
  sandstone: 249,
  sandstone_slab: 249,
  sandstone_stairs: 249,
  sandstone_wall: 243,
  scaffolding: 174,
  sculk: 1,
  sculk_catalyst: 1,
  sculk_sensor: 16,
  sculk_shrieker: 245,
  sculk_vein: 8,
  sea_lantern: 240,
  sea_pickle: 74,
  seagrass: 72,
  short_grass: 85,
  shroomlight: 216,
  shulker_box: 130,
  skeleton_skull: 33,
  skeleton_wall_skull: 33,
  slime_block: 206,
  small_amethyst_bud: 140,
  small_dripleaf: 108,
  smithing_table: 22,
  smoker: 69,
  smooth_basalt: 46,
  smooth_quartz: 254,
  smooth_quartz_slab: 254,
  smooth_quartz_stairs: 254,
  smooth_red_sandstone: 136,
  smooth_red_sandstone_slab: 136,
  smooth_red_sandstone_stairs: 136,
  smooth_sandstone: 249,
  smooth_sandstone_slab: 249,
  smooth_sandstone_stairs: 249,
  smooth_stone: 209,
  smooth_stone_slab: 209,
  sniffer_egg: 116,
  snow: 255,
  snow_block: 255,
  soul_campfire: 49,
  soul_fire: 212,
  soul_lantern: 88,
  soul_sand: 33,
  soul_soil: 33,
  soul_torch: 124,
  soul_wall_torch: 124,
  spawner: 11,
  sponge: 221,
  spore_blossom: 144,
  spruce_button: 79,
  spruce_door: 66,
  spruce_fence: 79,
  spruce_fence_gate: 79,
  spruce_hanging_sign: 79,
  spruce_leaves: 23,
  spruce_log: 66,
  spruce_planks: 79,
  spruce_pressure_plate: 79,
  spruce_sapling: 17,
  spruce_sign: 79,
  spruce_slab: 79,
  spruce_stairs: 79,
  spruce_trapdoor: 66,
  spruce_wall_hanging_sign: 79,
  spruce_wall_sign: 79,
  spruce_wood: 9,
  sticky_piston: 99,
  stone: 160,
  stone_brick_slab: 143,
  stone_brick_stairs: 143,
  stone_brick_wall: 143,
  stone_bricks: 143,
  stone_button: 160,
  stone_pressure_plate: 160,
  stone_slab: 160,
  stone_stairs: 160,
  stonecutter: 135,
  stripped_acacia_log: 119,
  stripped_acacia_wood: 119,
  stripped_bamboo_block: 218,
  stripped_birch_log: 222,
  stripped_birch_wood: 222,
  stripped_cherry_log: 224,
  stripped_cherry_wood: 224,
  stripped_crimson_hyphae: 67,
  stripped_crimson_stem: 64,
  stripped_dark_oak_log: 9,
  stripped_dark_oak_wood: 29,
  stripped_jungle_log: 179,
  stripped_jungle_wood: 179,
  stripped_mangrove_log: 24,
  stripped_mangrove_wood: 55,
  stripped_oak_log: 174,
  stripped_oak_wood: 199,
  stripped_spruce_log: 66,
  stripped_spruce_wood: 79,
  stripped_warped_hyphae: 141,
  stripped_warped_stem: 103,
  structure_block: 22,
  sugar_cane: 118,
  sunflower: 96,
  suspicious_gravel: 160,
  suspicious_sand: 249,
  sweet_berry_bush: 37,
  tall_grass: 62,
  tall_seagrass: 72,
  target: 224,
  terracotta: 106,
  tinted_glass: 7,
  tnt: 60,
  torch: 139,
  torchflower: 98,
  torchflower_crop: 51,
  trapped_chest: 174,
  trial_spawner: 52,
  tripwire: 160,
  tripwire_hook: 174,
  tube_coral: 75,
  tube_coral_block: 75,
  tube_coral_fan: 75,
  tube_coral_wall_fan: 75,
  tuff: 135,
  tuff_brick_slab: 98,
  tuff_brick_stairs: 98,
  tuff_brick_wall: 98,
  tuff_bricks: 98,
  tuff_slab: 135,
  tuff_stairs: 135,
  tuff_wall: 135,
  turtle_egg: 252,
  twisting_vines: 93,
  twisting_vines_plant: 93,
  vault: 37,
  verdant_froglight: 254,
  vine: 25,
  wall_torch: 139,
  warped_button: 71,
  warped_door: 87,
  warped_fence: 71,
  warped_fence_gate: 71,
  warped_fungus: 89,
  warped_hanging_sign: 141,
  warped_hyphae: 22,
  warped_nylium: 87,
  warped_planks: 71,
  warped_pressure_plate: 71,
  warped_roots: 93,
  warped_sign: 71,
  warped_slab: 71,
  warped_stairs: 71,
  warped_stem: 89,
  warped_trapdoor: 90,
  warped_wall_hanging_sign: 141,
  warped_wall_sign: 71,
  warped_wart_block: 77,
  water: 57,
  water_cauldron: 5,
  waxed_chiseled_copper: 149,
  waxed_copper_block: 169,
  waxed_copper_bulb: 110,
  waxed_copper_door: 149,
  waxed_copper_grate: 164,
  waxed_copper_trapdoor: 162,
  waxed_cut_copper: 162,
  waxed_cut_copper_slab: 162,
  waxed_cut_copper_stairs: 162,
  waxed_exposed_chiseled_copper: 152,
  waxed_exposed_copper: 183,
  waxed_exposed_copper_bulb: 126,
  waxed_exposed_copper_door: 146,
  waxed_exposed_copper_grate: 183,
  waxed_exposed_copper_trapdoor: 183,
  waxed_exposed_cut_copper: 180,
  waxed_exposed_cut_copper_slab: 180,
  waxed_exposed_cut_copper_stairs: 180,
  waxed_oxidized_chiseled_copper: 178,
  waxed_oxidized_copper: 185,
  waxed_oxidized_copper_bulb: 120,
  waxed_oxidized_copper_door: 159,
  waxed_oxidized_copper_grate: 167,
  waxed_oxidized_copper_trapdoor: 178,
  waxed_oxidized_cut_copper: 167,
  waxed_oxidized_cut_copper_slab: 167,
  waxed_oxidized_cut_copper_stairs: 167,
  waxed_weathered_chiseled_copper: 165,
  waxed_weathered_copper: 172,
  waxed_weathered_copper_bulb: 122,
  waxed_weathered_copper_door: 165,
  waxed_weathered_copper_grate: 172,
  waxed_weathered_copper_trapdoor: 176,
  waxed_weathered_cut_copper: 165,
  waxed_weathered_cut_copper_slab: 165,
  waxed_weathered_cut_copper_stairs: 165,
  weathered_chiseled_copper: 165,
  weathered_copper: 172,
  weathered_copper_bulb: 122,
  weathered_copper_door: 165,
  weathered_copper_grate: 172,
  weathered_copper_trapdoor: 176,
  weathered_cut_copper: 165,
  weathered_cut_copper_slab: 165,
  weathered_cut_copper_stairs: 165,
  weeping_vines: 4,
  weeping_vines_plant: 12,
  wet_sponge: 217,
  wheat: 56,
  white_banner: 174,
  white_bed: 174,
  white_candle: 250,
  white_candle_cake: 250,
  white_carpet: 254,
  white_concrete: 250,
  white_concrete_powder: 254,
  white_glazed_terracotta: 246,
  white_shulker_box: 251,
  white_stained_glass: 255,
  white_stained_glass_pane: 255,
  white_terracotta: 232,
  white_tulip: 182,
  white_wall_banner: 174,
  white_wool: 254,
  wither_rose: 3,
  wither_skeleton_skull: 33,
  wither_skeleton_wall_skull: 33,
  yellow_banner: 174,
  yellow_bed: 174,
  yellow_candle: 215,
  yellow_candle_cake: 215,
  yellow_carpet: 238,
  yellow_concrete: 231,
  yellow_concrete_powder: 238,
  yellow_glazed_terracotta: 235,
  yellow_shulker_box: 231,
  yellow_stained_glass: 247,
  yellow_stained_glass_pane: 247,
  yellow_terracotta: 184,
  yellow_wall_banner: 174,
  yellow_wool: 238,
  zombie_head: 33,
  zombie_wall_head: 33
}
